import statesWithSchools from './states-with-schools.json';

export interface School {
  schoolFiceId: string;
  schoolName: string;
}

export interface StatesWithSchools {
  stateCode: string;
  stateName: string;
  schools: School[];
}

export async function getStatesWithSchools() {
  return statesWithSchools as StatesWithSchools[];
}

export function getSchoolsByStateCode(
  states: StatesWithSchools[],
  stateCode: string
) {
  return states.find((state) => state.stateCode === stateCode)?.schools || [];
}

export function getSchoolByFiceId(listOfSchools: School[], ficeId: string) {
  return listOfSchools.find((state) => state.schoolFiceId === ficeId);
}

export function findStateInfoBySchoolId(id: string): StatesWithSchools {
  const stateInfo = statesWithSchools.find(
    (state) => !!state.schools.find((s) => s.schoolFiceId === id)
  );
  return stateInfo;
}
